import MedalBadge from "./medal-badge";

export default function LeaderboardSection({
  title,
  data,
  userRank,
  userName,
  userPoints,
  userImage,
  onUserClick,
}) {
  return (
    <div
      className="mb-3"
      style={{
        overflow: "hidden",
        border: "1px solid #2A4051",
        backgroundColor: "#1C2A37",
        borderRadius: "12px",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #2A4051",
          background:
            "linear-gradient(to right, rgba(26,40,54,0.8), rgba(28,42,55,0.6))",
          padding: "12px",
        }}
      >
        <h3
          style={{ fontWeight: 600, fontSize: 14, color: "#E6ECF1", margin: 0 }}
        >
          {title}
        </h3>
      </div>
      <div>
        {data && data.length > 0 ? (
          <>
            {data.map((item) => (
              <div
                key={item.rank}
                className="d-flex align-items-center"
                role="button"
                onClick={() => onUserClick?.(item.user_id ?? item.id, item)}
                style={{
                  cursor: "pointer",
                  gap: 12,
                  padding: "12px",
                  borderTop: "1px solid rgba(42,64,81,0.3)",
                }}
              >
                <MedalBadge rank={item.rank} />

                <div
                  className="d-flex align-items-center"
                  style={{ gap: 12, minWidth: 0, flex: 1 }}
                >
                  <img
                    src={item.image || "/placeholder.svg"}
                    alt={item.name}
                    style={{
                      height: 32,
                      width: 32,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border:
                        "1px solid color-mix(in srgb, var(--Primary-500), transparent 70%)",
                      flexShrink: 0,
                    }}
                  />
                  <span
                    className="text-truncate"
                    style={{ fontSize: 14, fontWeight: 500, color: "#E6ECF1" }}
                  >
                    {item.name}
                  </span>
                </div>

                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "var(--Primary-500)",
                    whiteSpace: "nowrap",
                  }}
                >
                  +{item.points}
                </span>
              </div>
            ))}

            {userRank ? (
              <>
                <div
                  style={{
                    borderTop:
                      "2px solid color-mix(in srgb, var(--Primary-500), transparent 70%)",
                    padding: "8px 12px",
                    backgroundColor:
                      "color-mix(in srgb, var(--Primary-500), transparent 90%)",
                  }}
                >
                  <p
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--Primary-500)",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                      margin: 0,
                    }}
                  >
                    Your Rank
                  </p>
                </div>

                <div
                  className="d-flex align-items-center"
                  role="button"
                  style={{
                    cursor: "pointer",
                    gap: 12,
                    padding: "12px",
                    backgroundColor: "#1a2836",
                    borderTop:
                      "1px solid color-mix(in srgb, var(--Primary-500), transparent 90%)",
                  }}
                >
                  <MedalBadge rank={userRank} />
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: 12, minWidth: 0, flex: 1 }}
                  >
                    <img
                      src={userImage || "/placeholder.svg"}
                      alt={userName}
                      style={{
                        height: 32,
                        width: 32,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border:
                          "1px solid color-mix(in srgb, var(--Primary-500), transparent 50%)",
                        flexShrink: 0,
                      }}
                    />
                    <span
                      className="text-truncate"
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#E6ECF1",
                      }}
                    >
                      {userName}
                    </span>
                  </div>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "var(--Primary-500)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    +{userPoints}
                  </span>
                </div>
              </>
            ) : null}
          </>
        ) : (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#8B9EAE",
              fontSize: 14,
            }}
          >
            No data available
          </div>
        )}
      </div>
    </div>
  );
}
